export const paysList = {
    AF: { fr: 'Afghanistan', en: 'Afghanistan', es: 'Afganistán' },
    ZA: { fr: 'Afrique du Sud', en: 'South Africa', es: 'Sudáfrica' },
    AL: { fr: 'Albanie', en: 'Albania', es: 'Albania' },
    DZ: { fr: 'Algérie', en: 'Algeria', es: 'Argelia' },
    DE: { fr: 'Allemagne', en: 'Germany', es: 'Alemania' },
    AD: { fr: 'Andorre', en: 'Andorra', es: 'Andorra' },
    AO: { fr: 'Angola', en: 'Angola', es: 'Angola' },
    AI: { fr: 'Anguilla', en: 'Anguilla', es: 'Anguila' },
    AQ: { fr: 'Antarctique', en: 'Antarctica', es: 'Antártida' },
    AG: { fr: 'Antigua-et-Barbuda', en: 'Antigua and Barbuda', es: 'Antigua y Barbuda' },
    SA: { fr: 'Arabie saoudite', en: 'Saudi Arabia', es: 'Arabia Saudita' },
    AR: { fr: 'Argentine', en: 'Argentina', es: 'Argentina' },
    AM: { fr: 'Arménie', en: 'Armenia', es: 'Armenia' },
    AW: { fr: 'Aruba', en: 'Aruba', es: 'Aruba' },
    AU: { fr: 'Australie', en: 'Australia', es: 'Australia' },
    AT: { fr: 'Autriche', en: 'Austria', es: 'Austria' },
    AZ: { fr: 'Azerbaïdjan', en: 'Azerbaijan', es: 'Azerbaiyán' },
    BS: { fr: 'Bahamas', en: 'Bahamas', es: 'Bahamas' },
    BH: { fr: 'Bahreïn', en: 'Bahrain', es: 'Baréin' },
    BD: { fr: 'Bangladesh', en: 'Bangladesh', es: 'Bangladés' },
    BB: { fr: 'Barbade', en: 'Barbados', es: 'Barbados' },
    BY: { fr: 'Biélorussie', en: 'Belarus', es: 'Bielorrusia' },
    BE: { fr: 'Belgique', en: 'Belgium', es: 'Bélgica' },
    BZ: { fr: 'Belize', en: 'Belize', es: 'Belice' },
    BJ: { fr: 'Bénin', en: 'Benin', es: 'Benín' },
    BM: { fr: 'Bermudes', en: 'Bermuda', es: 'Bermudas' },
    BT: { fr: 'Bhoutan', en: 'Bhutan', es: 'Bután' },
    BO: { fr: 'Bolivie', en: 'Bolivia', es: 'Bolivia' },
    BA: { fr: 'Bosnie-Herzégovine', en: 'Bosnia and Herzegovina', es: 'Bosnia y Herzegovina' },
    BW: { fr: 'Botswana', en: 'Botswana', es: 'Botsuana' },
    BR: { fr: 'Brésil', en: 'Brazil', es: 'Brasil' },
    BN: { fr: 'Brunei', en: 'Brunei', es: 'Brunéi' },
    BG: { fr: 'Bulgarie', en: 'Bulgaria', es: 'Bulgaria' },
    BF: { fr: 'Burkina Faso', en: 'Burkina Faso', es: 'Burkina Faso' },
    BI: { fr: 'Burundi', en: 'Burundi', es: 'Burundi' },
    KH: { fr: 'Cambodge', en: 'Cambodia', es: 'Camboya' },
    CM: { fr: 'Cameroun', en: 'Cameroon', es: 'Camerún' },
    CA: { fr: 'Canada', en: 'Canada', es: 'Canadá' },
    CV: { fr: 'Cap-Vert', en: 'Cape Verde', es: 'Cabo Verde' },
    CL: { fr: 'Chili', en: 'Chile', es: 'Chile' },
    CN: { fr: 'Chine', en: 'China', es: 'China' },
    CY: { fr: 'Chypre', en: 'Cyprus', es: 'Chipre' },
    CO: { fr: 'Colombie', en: 'Colombia', es: 'Colombia' },
    KM: { fr: 'Comores', en: 'Comoros', es: 'Comoras' },
    CG: { fr: 'Congo', en: 'Congo', es: 'Congo' },
    CD: { fr: 'Congo (RDC)', en: 'Congo (DRC)', es: 'Congo (RDC)' },
    KP: { fr: 'Corée du Nord', en: 'North Korea', es: 'Corea del Norte' },
    KR: { fr: 'Corée du Sud', en: 'South Korea', es: 'Corea del Sur' },
    CR: { fr: 'Costa Rica', en: 'Costa Rica', es: 'Costa Rica' },
    CI: { fr: "Côte d'Ivoire", en: 'Ivory Coast', es: 'Costa de Marfil' },
    HR: { fr: 'Croatie', en: 'Croatia', es: 'Croacia' },
    CU: { fr: 'Cuba', en: 'Cuba', es: 'Cuba' },
    CW: { fr: 'Curaçao', en: 'Curaçao', es: 'Curazao' },
    DK: { fr: 'Danemark', en: 'Denmark', es: 'Dinamarca' },
    DJ: { fr: 'Djibouti', en: 'Djibouti', es: 'Yibuti' },
    DM: { fr: 'Dominique', en: 'Dominica', es: 'Dominica' },
    EG: { fr: 'Égypte', en: 'Egypt', es: 'Egipto' },
    AE: { fr: 'Émirats arabes unis', en: 'United Arab Emirates', es: 'Emiratos Árabes Unidos' },
    EC: { fr: 'Équateur', en: 'Ecuador', es: 'Ecuador' },
    ER: { fr: 'Érythrée', en: 'Eritrea', es: 'Eritrea' },
    ES: { fr: 'Espagne', en: 'Spain', es: 'España' },
    EE: { fr: 'Estonie', en: 'Estonia', es: 'Estonia' },
    US: { fr: 'États-Unis', en: 'United States', es: 'Estados Unidos' },
    ET: { fr: 'Éthiopie', en: 'Ethiopia', es: 'Etiopía' },
    FJ: { fr: 'Fidji', en: 'Fiji', es: 'Fiyi' },
    FI: { fr: 'Finlande', en: 'Finland', es: 'Finlandia' },
    FR: { fr: 'France', en: 'France', es: 'Francia' },
    GA: { fr: 'Gabon', en: 'Gabon', es: 'Gabón' },
    GM: { fr: 'Gambie', en: 'Gambia', es: 'Gambia' },
    GE: { fr: 'Géorgie', en: 'Georgia', es: 'Georgia' },
    GH: { fr: 'Ghana', en: 'Ghana', es: 'Ghana' },
    GI: { fr: 'Gibraltar', en: 'Gibraltar', es: 'Gibraltar' },
    GR: { fr: 'Grèce', en: 'Greece', es: 'Grecia' },
    GD: { fr: 'Grenade', en: 'Grenada', es: 'Granada' },
    GL: { fr: 'Groenland', en: 'Greenland', es: 'Groenlandia' },
    GP: { fr: 'Guadeloupe', en: 'Guadeloupe', es: 'Guadalupe' },
    GU: { fr: 'Guam', en: 'Guam', es: 'Guam' },
    GT: { fr: 'Guatemala', en: 'Guatemala', es: 'Guatemala' },
    GG: { fr: 'Guernesey', en: 'Guernsey', es: 'Guernsey' },
    GN: { fr: 'Guinée', en: 'Guinea', es: 'Guinea' },
    GQ: { fr: 'Guinée équatoriale', en: 'Equatorial Guinea', es: 'Guinea Ecuatorial' },
    GW: { fr: 'Guinée-Bissau', en: 'Guinea-Bissau', es: 'Guinea-Bisáu' },
    GY: { fr: 'Guyana', en: 'Guyana', es: 'Guyana' },
    GF: { fr: 'Guyane française', en: 'French Guiana', es: 'Guayana Francesa' },
    HT: { fr: 'Haïti', en: 'Haiti', es: 'Haití' },
    HN: { fr: 'Honduras', en: 'Honduras', es: 'Honduras' },
    HK: { fr: 'Hong Kong', en: 'Hong Kong', es: 'Hong Kong' },
    HU: { fr: 'Hongrie', en: 'Hungary', es: 'Hungría' },
    IN: { fr: 'Inde', en: 'India', es: 'India' },
    ID: { fr: 'Indonésie', en: 'Indonesia', es: 'Indonesia' },
    IQ: { fr: 'Irak', en: 'Iraq', es: 'Irak' },
    IR: { fr: 'Iran', en: 'Iran', es: 'Irán' },
    IE: { fr: 'Irlande', en: 'Ireland', es: 'Irlanda' },
    IS: { fr: 'Islande', en: 'Iceland', es: 'Islandia' },
    IL: { fr: 'Israël', en: 'Israel', es: 'Israel' },
    IT: { fr: 'Italie', en: 'Italy', es: 'Italia' },
    JM: { fr: 'Jamaïque', en: 'Jamaica', es: 'Jamaica' },
    JP: { fr: 'Japon', en: 'Japan', es: 'Japón' },
    JE: { fr: 'Jersey', en: 'Jersey', es: 'Jersey' },
    JO: { fr: 'Jordanie', en: 'Jordan', es: 'Jordania' },
    KZ: { fr: 'Kazakhstan', en: 'Kazakhstan', es: 'Kazajistán' },
    KE: { fr: 'Kenya', en: 'Kenya', es: 'Kenia' },
    KG: { fr: 'Kirghizistan', en: 'Kyrgyzstan', es: 'Kirguistán' },
    KI: { fr: 'Kiribati', en: 'Kiribati', es: 'Kiribati' },
    KW: { fr: 'Koweït', en: 'Kuwait', es: 'Kuwait' },
    LA: { fr: 'Laos', en: 'Laos', es: 'Laos' },
    LS: { fr: 'Lesotho', en: 'Lesotho', es: 'Lesoto' },
    LV: { fr: 'Lettonie', en: 'Latvia', es: 'Letonia' },
    LB: { fr: 'Liban', en: 'Lebanon', es: 'Líbano' },
    LR: { fr: 'Liberia', en: 'Liberia', es: 'Liberia' },
    LY: { fr: 'Libye', en: 'Libya', es: 'Libia' },
    LI: { fr: 'Liechtenstein', en: 'Liechtenstein', es: 'Liechtenstein' },
    LT: { fr: 'Lituanie', en: 'Lithuania', es: 'Lituania' },
    LU: { fr: 'Luxembourg', en: 'Luxembourg', es: 'Luxemburgo' },
    MO: { fr: 'Macao', en: 'Macau', es: 'Macao' },
    MK: { fr: 'Macédoine du Nord', en: 'North Macedonia', es: 'Macedonia del Norte' },
    MG: { fr: 'Madagascar', en: 'Madagascar', es: 'Madagascar' },
    MY: { fr: 'Malaisie', en: 'Malaysia', es: 'Malasia' },
    MW: { fr: 'Malawi', en: 'Malawi', es: 'Malaui' },
    MV: { fr: 'Maldives', en: 'Maldives', es: 'Maldivas' },
    ML: { fr: 'Mali', en: 'Mali', es: 'Malí' },
    MT: { fr: 'Malte', en: 'Malta', es: 'Malta' },
    MA: { fr: 'Maroc', en: 'Morocco', es: 'Marruecos' },
    MH: { fr: 'Îles Marshall', en: 'Marshall Islands', es: 'Islas Marshall' },
    MQ: { fr: 'Martinique', en: 'Martinique', es: 'Martinica' },
    MU: { fr: 'Maurice', en: 'Mauritius', es: 'Mauricio' },
    MR: { fr: 'Mauritanie', en: 'Mauritania', es: 'Mauritania' },
    YT: { fr: 'Mayotte', en: 'Mayotte', es: 'Mayotte' },
    MX: { fr: 'Mexique', en: 'Mexico', es: 'México' },
    FM: { fr: 'Micronésie', en: 'Micronesia', es: 'Micronesia' },
    MD: { fr: 'Moldavie', en: 'Moldova', es: 'Moldavia' },
    MC: { fr: 'Monaco', en: 'Monaco', es: 'Mónaco' },
    MN: { fr: 'Mongolie', en: 'Mongolia', es: 'Mongolia' },
    ME: { fr: 'Monténégro', en: 'Montenegro', es: 'Montenegro' },
    MS: { fr: 'Montserrat', en: 'Montserrat', es: 'Montserrat' },
    MZ: { fr: 'Mozambique', en: 'Mozambique', es: 'Mozambique' },
    MM: { fr: 'Myanmar', en: 'Myanmar', es: 'Myanmar' },
    NA: { fr: 'Namibie', en: 'Namibia', es: 'Namibia' },
    NR: { fr: 'Nauru', en: 'Nauru', es: 'Nauru' },
    NP: { fr: 'Népal', en: 'Nepal', es: 'Nepal' },
    NI: { fr: 'Nicaragua', en: 'Nicaragua', es: 'Nicaragua' },
    NE: { fr: 'Niger', en: 'Niger', es: 'Níger' },
    NG: { fr: 'Nigeria', en: 'Nigeria', es: 'Nigeria' },
    NU: { fr: 'Niue', en: 'Niue', es: 'Niue' },
    NO: { fr: 'Norvège', en: 'Norway', es: 'Noruega' },
    NC: { fr: 'Nouvelle-Calédonie', en: 'New Caledonia', es: 'Nueva Caledonia' },
    NZ: { fr: 'Nouvelle-Zélande', en: 'New Zealand', es: 'Nueva Zelanda' },
    OM: { fr: 'Oman', en: 'Oman', es: 'Omán' },
    UG: { fr: 'Ouganda', en: 'Uganda', es: 'Uganda' },
    UZ: { fr: 'Ouzbékistan', en: 'Uzbekistan', es: 'Uzbekistán' },
    PK: { fr: 'Pakistan', en: 'Pakistan', es: 'Pakistán' },
    PW: { fr: 'Palaos', en: 'Palau', es: 'Palaos' },
    PS: { fr: 'Palestine', en: 'Palestine', es: 'Palestina' },
    PA: { fr: 'Panama', en: 'Panama', es: 'Panamá' },
    PG: { fr: 'Papouasie-Nouvelle-Guinée', en: 'Papua New Guinea', es: 'Papúa Nueva Guinea' },
    PY: { fr: 'Paraguay', en: 'Paraguay', es: 'Paraguay' },
    NL: { fr: 'Pays-Bas', en: 'Netherlands', es: 'Países Bajos' },
    PE: { fr: 'Pérou', en: 'Peru', es: 'Perú' },
    PH: { fr: 'Philippines', en: 'Philippines', es: 'Filipinas' },
    PL: { fr: 'Pologne', en: 'Poland', es: 'Polonia' },
    PF: { fr: 'Polynésie française', en: 'French Polynesia', es: 'Polinesia Francesa' },
    PR: { fr: 'Porto Rico', en: 'Puerto Rico', es: 'Puerto Rico' },
    PT: { fr: 'Portugal', en: 'Portugal', es: 'Portugal' },
    QA: { fr: 'Qatar', en: 'Qatar', es: 'Catar' },
    DO: { fr: 'République dominicaine', en: 'Dominican Republic', es: 'República Dominicana' },
    CZ: { fr: 'République tchèque', en: 'Czech Republic', es: 'República Checa' },
    RE: { fr: 'Réunion', en: 'Réunion', es: 'Reunión' },
    RO: { fr: 'Roumanie', en: 'Romania', es: 'Rumania' },
    GB: { fr: 'Royaume-Uni', en: 'United Kingdom', es: 'Reino Unido' },
    RU: { fr: 'Russie', en: 'Russia', es: 'Rusia' },
    RW: { fr: 'Rwanda', en: 'Rwanda', es: 'Ruanda' },
    EH: { fr: 'Sahara occidental', en: 'Western Sahara', es: 'Sahara Occidental' },
    BL: { fr: 'Saint-Barthélemy', en: 'Saint Barthélemy', es: 'San Bartolomé' },
    KN: { fr: 'Saint-Kitts-et-Nevis', en: 'Saint Kitts and Nevis', es: 'San Cristóbal y Nieves' },
    SM: { fr: 'Saint-Marin', en: 'San Marino', es: 'San Marino' },
    MF: { fr: 'Saint-Martin', en: 'Saint Martin', es: 'San Martín' },
    PM: { fr: 'Saint-Pierre-et-Miquelon', en: 'Saint Pierre and Miquelon', es: 'San Pedro y Miquelón' },
    VC: { fr: 'Saint-Vincent-et-les-Grenadines', en: 'Saint Vincent and the Grenadines', es: 'San Vicente y las Granadinas' },
    SB: { fr: 'Îles Salomon', en: 'Solomon Islands', es: 'Islas Salomón' },
    SV: { fr: 'Salvador', en: 'El Salvador', es: 'El Salvador' },
    WS: { fr: 'Samoa', en: 'Samoa', es: 'Samoa' },
    ST: { fr: 'Sao Tomé-et-Principe', en: 'São Tomé and Príncipe', es: 'Santo Tomé y Príncipe' },
    SN: { fr: 'Sénégal', en: 'Senegal', es: 'Senegal' },
    RS: { fr: 'Serbie', en: 'Serbia', es: 'Serbia' },
    SC: { fr: 'Seychelles', en: 'Seychelles', es: 'Seychelles' },
    SL: { fr: 'Sierra Leone', en: 'Sierra Leone', es: 'Sierra Leona' },
    SG: { fr: 'Singapour', en: 'Singapore', es: 'Singapur' },
    SK: { fr: 'Slovaquie', en: 'Slovakia', es: 'Eslovaquia' },
    SI: { fr: 'Slovénie', en: 'Slovenia', es: 'Eslovenia' },
    SO: { fr: 'Somalie', en: 'Somalia', es: 'Somalia' },
    SD: { fr: 'Soudan', en: 'Sudan', es: 'Sudán' },
    SS: { fr: 'Soudan du Sud', en: 'South Sudan', es: 'Sudán del Sur' },
    LK: { fr: 'Sri Lanka', en: 'Sri Lanka', es: 'Sri Lanka' },
    SE: { fr: 'Suède', en: 'Sweden', es: 'Suecia' },
    CH: { fr: 'Suisse', en: 'Switzerland', es: 'Suiza' },
    SR: { fr: 'Suriname', en: 'Suriname', es: 'Surinam' },
    SZ: { fr: 'Eswatini', en: 'Eswatini', es: 'Esuatini' },
    SY: { fr: 'Syrie', en: 'Syria', es: 'Siria' },
    TJ: { fr: 'Tadjikistan', en: 'Tajikistan', es: 'Tayikistán' },
    TW: { fr: 'Taïwan', en: 'Taiwan', es: 'Taiwán' },
    TZ: { fr: 'Tanzanie', en: 'Tanzania', es: 'Tanzania' },
    TD: { fr: 'Tchad', en: 'Chad', es: 'Chad' },
    TF: { fr: 'Terres australes françaises', en: 'French Southern Territories', es: 'Tierras Australes Francesas' },
    TH: { fr: 'Thaïlande', en: 'Thailand', es: 'Tailandia' },
    TL: { fr: 'Timor oriental', en: 'East Timor', es: 'Timor Oriental' },
    TG: { fr: 'Togo', en: 'Togo', es: 'Togo' },
    TO: { fr: 'Tonga', en: 'Tonga', es: 'Tonga' },
    TT: { fr: 'Trinité-et-Tobago', en: 'Trinidad and Tobago', es: 'Trinidad y Tobago' },
    TN: { fr: 'Tunisie', en: 'Tunisia', es: 'Túnez' },
    TM: { fr: 'Turkménistan', en: 'Turkmenistan', es: 'Turkmenistán' },
    TR: { fr: 'Turquie', en: 'Turkey', es: 'Turquía' },
    TV: { fr: 'Tuvalu', en: 'Tuvalu', es: 'Tuvalu' },
    UA: { fr: 'Ukraine', en: 'Ukraine', es: 'Ucrania' },
    UY: { fr: 'Uruguay', en: 'Uruguay', es: 'Uruguay' },
    VU: { fr: 'Vanuatu', en: 'Vanuatu', es: 'Vanuatu' },
    VA: { fr: 'Vatican', en: 'Vatican City', es: 'Vaticano' },
    VE: { fr: 'Venezuela', en: 'Venezuela', es: 'Venezuela' },
    VN: { fr: 'Vietnam', en: 'Vietnam', es: 'Vietnam' },
    WF: { fr: 'Wallis-et-Futuna', en: 'Wallis and Futuna', es: 'Wallis y Futuna' },
    YE: { fr: 'Yémen', en: 'Yemen', es: 'Yemen' },
    ZM: { fr: 'Zambie', en: 'Zambia', es: 'Zambia' },
    ZW: { fr: 'Zimbabwe', en: 'Zimbabwe', es: 'Zimbabue' },
}

export const getPaysOptions = (lang = 'fr') => {
    const safeLang = ['fr','en','es'].includes(lang) ? lang : 'fr'
    return Object.entries(paysList)
        .map(([code, labels]) => [code, labels[safeLang]])
        .sort((a,b) => a[1].localeCompare(b[1]))
}

export const getPaysLabel = (code, lang = 'fr') => {
    const safeLang = ['fr','en','es'].includes(lang) ? lang : 'fr'
    if(!code) return ''
    return (paysList[code] && paysList[code][safeLang]) ? paysList[code][safeLang] : code
}

// Pour les contextes hors composant React (générateurs PDF) qui ne peuvent pas utiliser useCookies
export const getCurrentLangFromCookie = () => {
    const cookieLang = document.cookie.replace(/(?:(?:^|.*;\s*)lang\s*\=\s*([^;]*).*$)|^.*$/, "$1")
    return cookieLang || 'fr'
}
